export {default as data} from './index.json';
import {Component} from 'intact';
import template from './index.vdt';
import './index.styl'; 

import {bind} from 'kpc';

type DemoItem = {
    key: number
    role: 'ai' | 'user'
    content: string
};

interface Props {
    roles: Record<string, any>
    items: DemoItem[]
}

function createRoles(): Props['roles'] {
    return {
        ai: {
            placement: 'start',
            avatar: true,
            roleName: 'AI 助手',
        },
        user: {
            placement: 'end',
            avatar: true,
            roleName: '我',
            variant: 'outlined',
        },
    };
}

function createItems(): DemoItem[] {
    return [
        {key: 1, role: 'ai', content: '你可以把 BubbleList 当作聊天列表的编排层。'},
        {key: 2, role: 'user', content: '那滚动和历史加载就交给它。'},
        {key: 3, role: 'ai', content: '对，Bubble 继续只管单条消息。'},
    ];
}

function createState(): Props {
    return {
        roles: createRoles(),
        items: createItems(),
    };
}

export default class extends Component<Props> {
    static template = template;

    static defaults() {
        return createState();
    }

    @bind
    retry(item: {content?: string | number}) {
        this.set({
            items: this.get('items').concat({
                key: Date.now(),
                role: 'ai',
                content: `重新生成：${item.content}`,
            }),
        });
    }
}